import React from "react";
import { Box, Button, Card, Typography } from "@mui/material";
import { documentsCard } from "../style";
import { useTranslation } from "react-i18next";
import documentsIcon from "../../../assets/images/icons/contract_doc.svg";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";
import { useNavigate } from "react-router-dom";

interface Document {
  name: string;
  description: string;
  documentBody: string | null;
  accepted: boolean;
}

interface DocumentsCardProps {
  tripId: string | undefined;
  terms?: {
    sop?: Document;
    duvri?: Document;
    generalTerms?: Document;
  } | null;
}

const DocumentsCard: React.FC<DocumentsCardProps> = ({ tripId, terms }) => {
  const { t } = useTranslation();
  const windowWidth = useWindowSize();
  const isMobile = windowWidth < 700;
  const navigate = useNavigate();

  // Funzione per creare un URL scaricabile
  const createDownloadLink = (base64: string | null, fileName: string) => {
    if (!base64) {
      console.error("Base64 string is null or undefined.");
      return null;
    }
  
    try {
      // Rimuovi prefissi se esistono, ad esempio: "data:application/pdf;base64,"
      const cleanBase64 = base64.includes(",") ? base64.split(",")[1] : base64;
  
      // Decodifica la stringa Base64 in un array di byte
      const binary = atob(cleanBase64);
      const binaryLength = binary.length;
      const bytes = new Uint8Array(binaryLength);
      for (let i = 0; i < binaryLength; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
  
      // Crea un Blob con il tipo MIME per PDF
      const blob = new Blob([bytes], { type: "application/pdf" });
  
      // Genera un URL per il download
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error while creating download link:", error);
      return null;
    }
  };
  

  return (
    <Card sx={documentsCard.card}>
      <Box sx={documentsCard.wrapper}>
        <Typography sx={isMobile ? documentsCard.titleM : documentsCard.titleD}>
          {t("screens.trips.documentsCard.allTransportDocuments")}
        </Typography>
        {!isMobile && (
          <Button
            variant="contained"
            onClick={() => navigate(`/tripdetails/${tripId}/documents`)}
            sx={documentsCard.subtitle}
          >
            {t("screens.trips.documentsCard.checkAllDocuments")}
          </Button>
        )}
      </Box>
      {terms?.sop?.documentBody && (
        <Button
          href={createDownloadLink(terms.sop.documentBody, terms.sop.name,) || "#"}
          download={terms.sop.name}
          variant="text"
          startIcon={
            <img
              src={documentsIcon}
              alt="Documents Icon"
              style={documentsCard.icon}
            />
          }
          sx={documentsCard.button}
          fullWidth={false}
        >
          SOP
        </Button>
      )}
      {terms?.generalTerms?.documentBody && (
        <Button
          href={
            createDownloadLink(
              terms.generalTerms.documentBody,
              terms.generalTerms.name,
            ) || "#"
          }
          download={terms.generalTerms.name}
          variant="text"
          startIcon={
            <img
              src={documentsIcon}
              alt="Documents Icon"
              style={documentsCard.icon}
            />
          }
          onClick={() => {}}
          sx={documentsCard.button}
          fullWidth={false}
        >
          {t("screens.trips.documentsCard.generalConditions")}
        </Button>
      )}
      {isMobile && (
        <Box sx={documentsCard.mobileWrapper}>
          <Button
            variant="contained"
            onClick={() => navigate(`/tripdetails/${tripId}/documents`)}
            sx={documentsCard.subtitle}
          >
            {t("screens.trips.documentsCard.checkAllDocuments")}
          </Button>
        </Box>
      )}
    </Card>
  );
};

export default DocumentsCard;
